import moment from 'moment';
import fields from './fields.utils.js';


const schema_sme = {
    ...fields.notes,
    //source
    'source_uuid': {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    'cover_level': {
        label: 'Cover Level',
        type: 'number',
        value: '',
        required: true,
    },
    'contact_name': {
        type: 'text',
        label: 'Contact name',
        value: '',
        required: true
    },
    'company_name': {
        type: 'text',
        label: 'Company name',
        value: '',
        required: true
    },
    'company_age': {
        label: 'company establishment date (Year)',
        type: 'date-mask',
        mask: '9999',
        value: moment().format('YYYY'),
        required: true,

        placeholder: 'Company year'
    },
    'company_business': {
        label: 'Company Business',
        type: 'auto-suggest',
        required: true,
        options: [],
    },
    'address1': {
        label: 'Company Address Line 1',
        placeholder: 'Address Line 1',
        value: '',
        type: 'text',
        required: true,
    },
    'address2': {
        label: 'Company Address Line 2',
        placeholder: 'Address Line 2',
        value: '',
        type: 'text',

    },
    'address3': {
        label: 'Company Address Line 3',
        placeholder: 'Address Line 3',
        type: 'text',
        value: '',

    },
    'address4': {
        label: 'Company Address Line 4',
        placeholder: 'Address Line 4',
        type: 'text',
        value: '',
    },
    'city': {
        label: 'Company City',
        placeholder: 'City',
        type: 'text',
        value: '',
        required: true,
    },
    'postcode': {
        label: 'Company Postal Code',
        placeholder: 'Postal Code',
        type: 'address-lookup',
        value: '',
        required: true,
    },
    'email': {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    'telephone': {
        label: 'Telephone',
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true,

    },
    ...fields.marketing,
    ...fields.cross_selling
};
export default schema_sme;
